"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftEpics = exports.giftVerifyAvailableContactEpic = exports.giftCancelEpic = exports.giftSetProductOptionsEpic = exports.giftUnexpireEpic = exports.giftExpireEpic = exports.giftUpdateEpic = exports.giftResearchPollingEpic = exports.giftSetVideoMessageEpic = exports.giftSetFullResearchEpic = exports.giftSetSendAs = exports.giftSetGiftActionsEpic = exports.giftDiscardEpic = exports.giftSelectProductEpic = exports.giftSelectExchangeProduct = exports.giftSendEpic = exports.giftLoadEpic = exports.giftCreateEpic = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _rxjs = require("rxjs");

var _queryString = _interopRequireDefault(require("query-string"));

var _services = require("@alycecom/services");

var _constants = require("../../constants");

var _gift = require("./gift.types");

var _gift2 = require("./gift.actions");

var _gift3 = require("./gift.selector");

var _message = require("./postcard/message");

var _message2 = require("./postcard/message/message.helpers");

var _invitationType = require("./invitationType");

var giftCreateEpic = function giftCreateEpic(action$, state$, _ref) {
  var createGiftService = _ref.createGiftService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_CREATE_REQUEST), (0, _operators.mergeMap)(function (action) {
    return createGiftService.createGift(action.payload).pipe((0, _operators.map)(function (response) {
      return (0, _gift2.giftCreateSuccess)(response.gift);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _gift2.giftCreateFail,
      showErrorsAsGlobal: true
    })));
  }));
};

exports.giftCreateEpic = giftCreateEpic;

var giftLoadEpic = function giftLoadEpic(action$, state$, _ref2) {
  var createGiftService = _ref2.createGiftService,
      errorHandler = _ref2.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_CREATE_LOAD_REQUEST), (0, _operators.mergeMap)(function (action) {
    return createGiftService.loadGift(action.payload).pipe((0, _operators.mergeMap)(function (response) {
      return [(0, _message.setTemplateMessage)((0, _message2.convertGiftWithShadowMessage)(response.gift)), (0, _gift2.giftLoadSuccess)(response.gift)];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _gift2.giftLoadFail
    })));
  }));
};

exports.giftLoadEpic = giftLoadEpic;

var giftSendEpic = function giftSendEpic(action$, state$, _ref3) {
  var createGiftService = _ref3.createGiftService;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_CREATE_SEND_REQUEST), (0, _operators.mergeMap)(function (action) {
    return createGiftService.sendGift({
      giftId: action.payload.giftId,
      scheduleAt: action.payload.scheduleAt
    }).pipe((0, _operators.mergeMap)(function (response) {
      return [(0, _gift2.giftSendSuccess)(response.data)];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleForbidden(), _services.handlers.handleAnyError(_gift2.giftSendFail))));
  }));
};

exports.giftSendEpic = giftSendEpic;

var giftSelectExchangeProduct = function giftSelectExchangeProduct(action$, state$, _ref4) {
  var createGiftService = _ref4.createGiftService,
      errorHandler = _ref4.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_CREATE_SELECT_EXCHANGE_PRODUCT), (0, _operators.mergeMap)(function (action) {
    return createGiftService.setExchangeProduct(action.payload.giftId, action.payload.product).pipe((0, _operators.mergeMap)(function (response) {
      return [(0, _gift2.giftSetProductSuccess)(response.gift), (0, _invitationType.editInvitationType)()];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _gift2.giftSetProductFail
    })));
  }));
};

exports.giftSelectExchangeProduct = giftSelectExchangeProduct;

var giftSelectProductEpic = function giftSelectProductEpic(action$, state$, _ref5) {
  var createGiftService = _ref5.createGiftService,
      errorHandler = _ref5.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_CREATE_SELECT_PRODUCT), (0, _operators.mergeMap)(function (action) {
    return createGiftService.setGiftProduct(action.payload.giftId, action.payload.productId).pipe((0, _operators.mergeMap)(function (response) {
      return [(0, _gift2.giftSetProductSuccess)(response.gift), (0, _invitationType.editInvitationType)()];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _gift2.giftSetProductFail
    })));
  }));
};

exports.giftSelectProductEpic = giftSelectProductEpic;

var giftDiscardEpic = function giftDiscardEpic(action$, state$, _ref6) {
  var createGiftService = _ref6.createGiftService,
      errorHandler = _ref6.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_DISCARD_REQUEST), (0, _operators.mergeMap)(function (action) {
    return createGiftService.discardGift(action.payload).pipe((0, _operators.map)(function () {
      return (0, _gift2.giftDiscardSuccess)(action.payload);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _gift2.giftDiscardFail
    })));
  }));
};

exports.giftDiscardEpic = giftDiscardEpic;

var giftSetGiftActionsEpic = function giftSetGiftActionsEpic(action$, state$, _ref7) {
  var createGiftService = _ref7.createGiftService,
      errorHandler = _ref7.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_SET_GIFT_ACTIONS_REQUEST), (0, _operators.mergeMap)(function (action) {
    return createGiftService.setGiftActions(action.payload.giftId, action.payload.giftActionsId, action.payload.prospect).pipe((0, _operators.mergeMap)(function (response) {
      return [(0, _gift2.giftSetGiftActionsSuccess)(response.gift), (0, _message.setTemplateMessage)((0, _message2.convertGiftToMessage)(response.gift))];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _gift2.giftSetGiftActionsFail
    })));
  }));
};

exports.giftSetGiftActionsEpic = giftSetGiftActionsEpic;

var giftSetSendAs = function giftSetSendAs(action$, state$, _ref8) {
  var createGiftService = _ref8.createGiftService,
      errorHandler = _ref8.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_SET_SEND_AS_REQUEST), (0, _operators.mergeMap)(function (action) {
    return createGiftService.setSendAs(action.payload.giftId, action.payload.userId).pipe((0, _operators.map)(function (response) {
      return (0, _gift2.giftSetSendAsSuccess)(response.gift);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _gift2.giftSetSendAsFail
    })));
  }));
};

exports.giftSetSendAs = giftSetSendAs;

var giftSetFullResearchEpic = function giftSetFullResearchEpic(action$, state$, _ref9) {
  var createGiftService = _ref9.createGiftService,
      errorHandler = _ref9.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.SET_FULL_RESEARCH.REQUEST), (0, _operators.mergeMap)(function (_ref10) {
    var giftId = _ref10.payload;
    return createGiftService.setFullResearchType(giftId).pipe((0, _operators.map)(function (response) {
      return (0, _gift2.giftSetFullResearchSuccess)(response.gift);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _gift2.giftSetFullResearchFail
    })));
  }));
};

exports.giftSetFullResearchEpic = giftSetFullResearchEpic;

var giftSetVideoMessageEpic = function giftSetVideoMessageEpic(action$, state$, _ref11) {
  var createGiftService = _ref11.createGiftService,
      errorHandler = _ref11.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_SET_VIDEO_MESSAGE_REQUEST), (0, _operators.debounceTime)(500), (0, _operators.mergeMap)(function (_ref12) {
    var payload = _ref12.payload;
    return createGiftService.setVideoMessage(payload).pipe((0, _operators.map)(function (response) {
      return (0, _gift2.giftSetVideoMessageSuccess)(response.gift);
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _gift2.giftSetVideoMessageFail
    })));
  }));
};

exports.giftSetVideoMessageEpic = giftSetVideoMessageEpic;

var giftResearchPollingEpic = function giftResearchPollingEpic(action$, state$, _ref13) {
  var createGiftService = _ref13.createGiftService;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.WAIT_FOR_INSTANT_RESEARCH.START), (0, _operators.withLatestFrom)(state$.pipe((0, _operators.map)(function (state) {
    return {
      giftId: (0, _gift3.getGiftId)(state)
    };
  }))), (0, _operators.switchMap)(function (_ref14) {
    var _ref15 = (0, _slicedToArray2.default)(_ref14, 2),
        giftId = _ref15[1].giftId;

    return (0, _rxjs.timer)(0, 5000).pipe((0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_gift.WAIT_FOR_INSTANT_RESEARCH.CANCEL, _gift.WAIT_FOR_INSTANT_RESEARCH.COMPLETE))), (0, _operators.switchMap)(function () {
      return createGiftService.getInstantResearchStatus(giftId).pipe((0, _operators.filter)(function (_ref16) {
        var updated = _ref16.updated;
        return updated;
      }), (0, _operators.mergeMap)(function () {
        return [(0, _gift2.waitForInstantResearchComplete)(), (0, _gift2.giftLoadRequest)(giftId)];
      }), (0, _operators.catchError)(function () {
        return _rxjs.EMPTY;
      }));
    }));
  }));
};

exports.giftResearchPollingEpic = giftResearchPollingEpic;

var giftUpdateEpic = function giftUpdateEpic(action$, state$, _ref17) {
  var createGiftService = _ref17.createGiftService,
      errorHandler = _ref17.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_REFRESH_LOAD_REQUEST), (0, _operators.mergeMap)(function (action) {
    return createGiftService.loadGift(action.payload.giftId).pipe((0, _operators.mergeMap)(function (response) {
      return [(0, _gift2.giftRefreshSuccess)(response.gift), (0, _gift2.selectTemplate)(action.payload.template)];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: _gift2.giftRefreshFail
    })));
  }));
};

exports.giftUpdateEpic = giftUpdateEpic;

var giftExpireEpic = function giftExpireEpic(action$, state$, _ref18) {
  var createGiftService = _ref18.createGiftService,
      messagesService = _ref18.messagesService;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_EXPIRE_REQUEST), (0, _operators.mergeMap)(function (action) {
    return createGiftService.expireGift(action.payload).pipe((0, _operators.mergeMap)(function (response) {
      return [(0, _gift2.giftExpireSuccess)(response.data), messagesService.showGlobalMessage({
        type: 'success',
        text: 'Your gift was expired.'
      })];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_gift2.giftExpireFail))));
  }));
};

exports.giftExpireEpic = giftExpireEpic;

var giftUnexpireEpic = function giftUnexpireEpic(action$, state$, _ref19) {
  var apiService = _ref19.apiService;
  return action$.pipe((0, _reduxObservable.ofType)(_gift2.giftUnexpire.pending), (0, _operators.withLatestFrom)(state$), (0, _operators.mergeMap)(function (_ref20) {
    var _ref21 = (0, _slicedToArray2.default)(_ref20, 2),
        state = _ref21[1];

    var id = (0, _gift3.getGiftId)(state);
    return apiService.post('/enterprise/gift-create/unexpire', {
      body: {
        id
      }
    }, true).pipe((0, _operators.mergeMap)(function (_ref22) {
      var data = _ref22.data;
      return [_gift2.giftUnexpire.fulfilled(data), (0, _services.showGlobalMessage)({
        type: _services.MessageType.Success,
        text: 'Your gift was unexpired.'
      })];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_gift2.giftUnexpire.rejected))));
  }));
};

exports.giftUnexpireEpic = giftUnexpireEpic;

var giftSetProductOptionsEpic = function giftSetProductOptionsEpic(action$, state$, _ref23) {
  var apiService = _ref23.apiService;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_SET_PRODUCT_OPTIONS_REQUEST), (0, _operators.withLatestFrom)(state$), (0, _operators.mergeMap)(function (_ref24) {
    var _action$payload;

    var _ref25 = (0, _slicedToArray2.default)(_ref24, 2),
        action = _ref25[0],
        state = _ref25[1];

    var id = (0, _gift3.getGiftId)(state);
    var options = null;

    if ((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.options) {
      options = Object.keys(action.payload.options).map(function (option) {
        return {
          attribute: option,
          value: action.payload.options[option]
        };
      });
    }

    return apiService.post("/enterprise/gifts/".concat(id, "/options"), {
      body: options
    }).pipe((0, _operators.mergeMap)(function (_ref26) {
      var data = _ref26.data;
      return [(0, _gift2.setGiftProductOptionsSuccess)(data), (0, _services.showGlobalMessage)({
        type: _services.MessageType.Success,
        text: 'Your gift was updated.'
      })];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_gift2.setGiftProductOptionsFailed))));
  }));
};

exports.giftSetProductOptionsEpic = giftSetProductOptionsEpic;

var giftCancelEpic = function giftCancelEpic(action$, state$, _ref27) {
  var createGiftService = _ref27.createGiftService,
      messagesService = _ref27.messagesService;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_CANCEL_REQUEST), (0, _operators.mergeMap)(function (action) {
    return createGiftService.cancelGift(action.payload).pipe((0, _operators.mergeMap)(function (response) {
      return [(0, _gift2.giftCancelSuccess)(response.data), messagesService.showGlobalMessage({
        type: 'success',
        text: 'Your gift was canceled.'
      })];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_gift2.giftCancelFail))));
  }));
};

exports.giftCancelEpic = giftCancelEpic;

var giftVerifyAvailableContactEpic = function giftVerifyAvailableContactEpic(action$, state$, _ref28) {
  var salesforceApiService = _ref28.salesforceApiService,
      messagesService = _ref28.messagesService;
  return action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_VERIFY_AVAILABLE_CONTACT_REQUEST), (0, _operators.switchMap)(function (_ref29) {
    var email = _ref29.payload.email;
    return (0, _rxjs.timer)(0, 3000).pipe((0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_gift.GIFT_VERIFY_AVAILABLE_CONTACT_SUCCESS, _gift.GIFT_VERIFY_AVAILABLE_CONTACT_FAILED))), (0, _operators.switchMap)(function () {
      return salesforceApiService.get("/salesforce/contacts?".concat(_queryString.default.stringify({
        email
      })), null, true).pipe((0, _operators.filter)(function (_ref30) {
        var _data$;

        var _ref30$data = _ref30.data,
            data = _ref30$data === void 0 ? [] : _ref30$data;
        return (// Verify if the Sync is Completed
          _constants.VALID_FINAL_STATUSES.includes((_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.status)
        );
      }), (0, _operators.map)(function (_ref31) {
        var _ref31$data = _ref31.data,
            data = _ref31$data === void 0 ? [] : _ref31$data;
        return (0, _gift2.giftVerifyAvailableContactSuccess)(data);
      }), (0, _operators.catchError)(messagesService.errorHandler({
        callbacks: _gift2.giftVerifyAvailableContactFailed
      })));
    }));
  }));
};

exports.giftVerifyAvailableContactEpic = giftVerifyAvailableContactEpic;
var giftEpics = [giftCreateEpic, giftLoadEpic, giftSendEpic, giftSelectProductEpic, giftDiscardEpic, giftSetGiftActionsEpic, giftSetSendAs, giftSelectExchangeProduct, giftResearchPollingEpic, giftSetFullResearchEpic, giftSetVideoMessageEpic, giftUpdateEpic, giftExpireEpic, giftUnexpireEpic, giftCancelEpic, giftVerifyAvailableContactEpic, giftSetProductOptionsEpic];
exports.giftEpics = giftEpics;